export const lightTheme = {
  dashboardBackground: '#E8EDEE',
  componentBackground: '#F7F7F9',
  textColor: '#111111',
  subTextColor: '#707070',
  logoFill: '#1C384E',
  borderColor: '#E1E0E6'
};

export const darkTheme = {
  dashboardBackground: '#1C384E',
  componentBackground: '#224056',
  textColor: '#FFFFFF',
  subTextColor: '#C8C7CD',
  logoFill: '#FFFFFF',
  borderColor: '#E1E0E6'
};